import { all, call } from "redux-saga/effects";
import onCreateSubject from "./createSubject";
import onGetSubject from "./getAllSubject";
import onSubjectDelete from "./deleteSubject";
import onEditSubject from "./editSubject";

export default function* subjectSagas() {
  yield all([
    call(onGetSubject),
    call(onCreateSubject),
    call(onSubjectDelete),
    call(onEditSubject),
  ]);
}
